<template>
  <div class="menuAdmin">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div v-loading="dialogLoading">
        <tree-table
          ref="tree"
          style="max-height: 500px; overflow: auto"
          expand-key="menuName"
          :expand-type="false"
          :is-fold="false"
          :tree-type="true"
          :selectable="true"
          :columns="selectMenusTableConfig"
          :data="selectMenus"
        >
        </tree-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOmAll,
  getAuthorityproxyMenu,
  getAuthoritysubProxyMenu,
  assignMenuToProxyCompany,
  assignMenuToSubProxyCompany,
} from "@/api/organization";
import { listConvertTree } from "@/api/util.js";
export default {
  props: {
    title: {
      type: String,
      default: '分配权限'
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      grantMenus: [],
      selectMenus: [],
      isExpired: false,
      status: "",
      selectMenusTableConfig: [
        {
          title: "菜单",
          key: "menuName",
          //   headerAlign: "center",
          //   align: "center",
          //   minWidth: "240px",
        },
      ],
    };
  },
  methods: {
    // 初始化
    init(status) {
      this.status = status;
      this.grantMenus = [];
      this.selectMenus = [];
      this.allotMenu();
    },
    allotMenu() {
      this.dialogVisible = true;
      this.dialogLoading = true;
      const that = this;
      const p1 = getOmAll();
      const p2 =
        this.status === "agency"
          ? getAuthorityproxyMenu()
          : getAuthoritysubProxyMenu();
      Promise.all([p1, p2])
        .then(function (values) {
          let res1 = values[0];
          let res2 = values[1];
          if (res1.code === 0 && res1.data) {
            let opt = {
              primaryKey: "menuId",
              parentKey: "parentId",
              startPid: "0",
            };
            if (res2.code === 0 && res2.data && res2.data.length > 0) {
              res2.data.map((item) => {
                // 菜单权限
                that.grantMenus.push(item.menuId);
              });
              // 时间
              if (res2.data.length > 0) {
                that.isExpired = res2.data[0].isExpired;
              }
            }
            res1.data.map((item) => {
              // 菜单选中
              if (that.grantMenus.includes(item.menuId)) {
                item._isChecked = true;
              }
            });
            that.selectMenus = listConvertTree(res1.data, opt);
          }
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.submitLoading = true;
      const authorityIds = this.getCheckedAuthorities();
      if (this.status === "agency") {
        assignMenuToProxyCompany({
          menuIds: authorityIds.join(),
        })
          .then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: "授权成功",
              });
              this.dialogVisible = false;
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } else if (this.status === "distribution") {
        assignMenuToSubProxyCompany({
          menuIds: authorityIds.join(),
        })
          .then((res) => {
            if (res.code === 0) {
              this.$parent.refresh();
              this.$message({
                type: "success",
                message: "授权成功",
              });
              this.dialogVisible = false;
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
    getCheckedAuthorities() {
      const menus = this.$refs["tree"].getCheckedProp("menuId");
      return menus;
    },
  },
};
</script>